import { Component, Element, Event, EventEmitter, h, Host, Listen, Prop, State } from '@stencil/core';
import { ProductData } from '../order-overview-component/order-overview-component';

@Component({
  tag: 'header-component',
  styleUrl: 'header-component.scss',
  shadow: true,
})
export class HeaderComponent {
  @Element() el: HTMLElement;
  @Prop() counter?: number;
  @Prop() brandSrcPath: string;
  @Prop() productData: ProductData[];
  @State() cartViewEnabled: boolean = false;
  @Event() linkClicked: EventEmitter;

  @Listen('click', { target: 'document' })
  handleClickOutside(event: MouseEvent) {
    const path = event.composedPath();

    const isClickInsideCartIcon = path.some((element: EventTarget) => {
      return element instanceof HTMLElement && element.classList.contains('shopping-cart');
    });

    const isClickInsideCartView = path.some((element: EventTarget) => {
      return element instanceof HTMLElement && element.tagName === 'SHOPPING-CART-VIEW';
    });
    if (!isClickInsideCartView && !isClickInsideCartIcon) {
      this.cartViewEnabled = false;
    }
  }

  handleClick() {
    this.cartViewEnabled = !this.cartViewEnabled;
  }

  cartEnabled() {
    return this.counter !== undefined;
  }

  handleLinkClick = () => {
    this.linkClicked.emit('faq');
  }
  handleLogoClick = () => {
    this.linkClicked.emit('unterlagenauswahl');
  }

  render() {
    return (
      <Host>
        <img class="logo" src={this.brandSrcPath} alt="Brand-logo" onClick={(this.handleLogoClick)}></img>
        <div class="title-container">
          <h4>Unterlagenshop</h4>
        </div>
        <div class="menu-items">

          <a class="about" onClick={(this.handleLinkClick)}>Über den Shop</a>
          <a class="material-icons-sharp help" onClick={(this.handleLinkClick)}>help</a>

          {this.cartEnabled() && (
            <div class="shopping-cart" onClick={() => this.handleClick()}>
              <i class="material-icons-sharp">shopping_cart</i>
              {this.counter !== 0 && (
                <div class="counter">
                  <div class="center">{this.counter}</div>
                </div>
              )}
            </div>
          )}
        </div>
        {this.cartViewEnabled && this.counter !== 0 && (
          <shopping-cart-view class="cart-view" productData={this.productData}>
            <slot slot="button" name="button"></slot>
          </shopping-cart-view>
        )}
      </Host>
    );
  }
}





